import { LogOut, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  getDischargeNoteBody,
  setDischargeNoteBody,
} from '../utils/dischargeNoteBody';

export default function DischargeNote({
  note,
  onChange,
  onDelete = null,
  readOnly = false,
  showTypeHeader = true,
}) {
  const { t } = useLanguage();
  const text = getDischargeNoteBody(note);

  return (
    <div className="flex flex-col gap-2.5">
      {showTypeHeader ? (
        <div className="flex items-center justify-between gap-2">
          <div className="flex min-w-0 items-center gap-2">
            <LogOut className="h-5 w-5 shrink-0 text-gray-900" strokeWidth={2} />
            <h2 className="text-base font-bold text-gray-900">{t('reportDischarge')}</h2>
          </div>
          {onDelete ? (
            <button
              type="button"
              onClick={onDelete}
              className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-primary"
              aria-label={t('removeNote')}
            >
              <X className="h-4 w-4" strokeWidth={2} />
            </button>
          ) : null}
        </div>
      ) : null}

      <textarea
        value={text}
        readOnly={readOnly}
        disabled={readOnly}
        placeholder={t('progressNotePlaceholder')}
        rows={10}
        onChange={(event) => {
          if (readOnly) return;
          onChange(setDischargeNoteBody(note, event.target.value));
        }}
        className="w-full resize-y rounded-xl border-0 bg-gray-100 px-3 py-3 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary/30"
        aria-label={t('reportDischarge')}
        dir="auto"
      />
    </div>
  );
}
